import _ from 'underscore';

import config from 'src/config';

function AttributionLinksEmailModalCtrl($q, $scope, $uibModalInstance, managementUserService, alertService, sdkUtils, attributionSources, event, eventService, organizationRelationshipService, organizationMemberService, venueService) { //eslint-disable-line
  $scope.saving = false;
  $scope.termsUrl = config.TERMS_URL;
  $scope.event = event;
  $scope.attributionSources = _.filter(attributionSources, attributionSource => attributionSource.type === 'MEMBER' || attributionSource.type === 'RELATIONSHIP');
  $scope.emailForm = {};
  $scope.selectedVenueIds = [];
  $scope.selectedOrganizationMembersIds = [];
  $scope.selectedOrganizationRelationshipsIds = [];
  $scope.currentStep = 1;

  $scope.close = function () {
    $uibModalInstance.close(false);
  };

  $q.all([
      organizationRelationshipService.getCurrentOrganizationRelationships(),
      organizationMemberService.getCurrentOrganizationMembers(),
      venueService.getCurrentVenues()
    ])
    .then(results => {
      $scope.organizationRelationships = _.reject(results[0], orgRelationship => {
        return orgRelationship.permissions && orgRelationship.permissions.length && _.findWhere(orgRelationship.permissions, {
          venue: $scope.event.venue
        });
      });
      $scope.selectedOrganizationRelationshipsIds = $scope.selectedOrganizationRelationshipsIds.concat($scope.organizationRelationships.map(rel => rel.id));
      $scope.organizationMembers = _.reject(results[1], orgMember => {
        return orgMember.venues && orgMember.venues.length && orgMember.venues.indexOf($scope.event.venue) > -1 && orgMember.type === 'STAFF';
      });
      $scope.selectedOrganizationMembersIds = $scope.selectedOrganizationMembersIds.concat($scope.organizationMembers.map(rel => rel.id));
      $scope.venues = results[2];
      $scope.selectedVenueIds = $scope.selectedVenueIds.concat($scope.venues.map(venue => venue.id));
    });

  $scope.noteOptions = {
    toolbar: [
      ['style', ['style']],
      ['style', ['bold', 'italic', 'underline']],
      ['fontsize', ['fontsize']],
      ['insert', ['link']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['height', ['height']]
    ],
    height: 140
  };

  $scope.nextStep = function () {
    if ($scope.currentStep === 2 && (!$scope.selectedOrganizationMembersIds.length && !$scope.selectedOrganizationRelationshipsIds.length)) {
      $scope.showStep2ErrorMsg = true;
      return;
    }

    $scope.showStep2ErrorMsg = false;

    $scope.currentStep = $scope.currentStep + 1; //eslint-disable-line
  };

  $scope.allStaffSelected = function () {
    $scope.organizationMembers = $scope.organizationMembers || [];
    return $scope.selectedOrganizationMembersIds.length === $scope.organizationMembers.length;
  };

  $scope.allPromotersSelected = function () {
    $scope.organizationRelationships = $scope.organizationRelationships || [];
    return $scope.selectedOrganizationRelationshipsIds.length === $scope.organizationRelationships.length;
  };

  $scope.toggleAllStaffSelected = function () {
    if ($scope.allStaffSelected()) {
      $scope.selectedOrganizationMembersIds.length = 0;
    } else {
      $scope.selectedOrganizationMembersIds = $scope.organizationMembers.map(member => member.id);
    }
  };

  $scope.toggleAllPromotersSelected = function () {
    if ($scope.allPromotersSelected()) {
      $scope.selectedOrganizationRelationshipsIds.length = 0;
    } else {
      $scope.selectedOrganizationRelationshipsIds = $scope.organizationRelationships.map(member => member.id);
    }
  };

  $scope.toggleVenueSelection = function (id) {
    const index = $scope.selectedVenueIds.indexOf(id);

    const orgMembersInVenue = _.filter($scope.organizationMembers, orgMember => {
      return orgMember.venues && orgMember.venues.length && orgMember.venues.indexOf(id) > -1;
    });

    const orgRelationshipsInVenue = _.filter($scope.organizationRelationships, orgRelationship => {
      return orgRelationship.permissions && orgRelationship.permissions.length && _.findWhere(orgRelationship.permissions, {
        venue: id
      });
    });

    if (index > -1) {
      $scope.selectedVenueIds.splice(index, 1);

      orgMembersInVenue.forEach(orgMember => $scope.removeOrganizationMemberSelection(orgMember.id));
      orgRelationshipsInVenue.forEach(orgRelationship => $scope.removeOrganizationRelationshipSelection(orgRelationship.id));
    } else {
      $scope.selectedVenueIds.push(id);

      orgMembersInVenue.forEach(orgMember => $scope.addOrganizationMemberSelection(orgMember.id));
      orgRelationshipsInVenue.forEach(orgRelationship => $scope.addOrganizationRelationshipSelection(orgRelationship.id));
    }
  };

  $scope.toggleOrganizationMemberSelection = function (id) {
    const index = $scope.selectedOrganizationMembersIds.indexOf(id);

    if (index > -1) {
      $scope.removeOrganizationMemberSelection(id);
    } else {
      $scope.addOrganizationMemberSelection(id);
    }
  };

  $scope.addOrganizationMemberSelection = function (id) {
    const index = $scope.selectedOrganizationMembersIds.indexOf(id);

    if (index < 0) {
      $scope.selectedOrganizationMembersIds.push(id);
    }
  };

  $scope.removeOrganizationMemberSelection = function (id) {
    const index = $scope.selectedOrganizationMembersIds.indexOf(id);

    $scope.selectedOrganizationMembersIds.splice(index, 1);
  };

  $scope.toggleOrganizationRelationshipSelection = function (id) {
    const index = $scope.selectedOrganizationRelationshipsIds.indexOf(id);

    if (index > -1) {
      $scope.removeOrganizationRelationshipSelection(id);
    } else {
      $scope.addOrganizationRelationshipSelection(id);
    }
  };

  $scope.addOrganizationRelationshipSelection = function (id) {
    const index = $scope.selectedOrganizationRelationshipsIds.indexOf(id);

    if (index < 0) {
      $scope.selectedOrganizationRelationshipsIds.push(id);
    }
  };

  $scope.removeOrganizationRelationshipSelection = function (id) {
    const index = $scope.selectedOrganizationRelationshipsIds.indexOf(id);

    $scope.selectedOrganizationRelationshipsIds.splice(index, 1);
  };

  $scope.sendEmail = function () {
    $scope.saving = true;

    return eventService.performActionById($scope.event.id, {
        type: 'SEND_ATTRIBUTION_LINKS',
        notes: $scope.emailForm.notes,
        organizationMemberIds: $scope.selectedOrganizationMembersIds && $scope.selectedOrganizationMembersIds.length ? $scope.selectedOrganizationMembersIds : null,
        organizationRelationshipIds: $scope.selectedOrganizationRelationshipsIds && $scope.selectedOrganizationRelationshipsIds.length ? $scope.selectedOrganizationRelationshipsIds : null
      })
      .then(() => {
        alertService.success('An email has been sent');

        $scope.close();
      })
      .catch(err => alertService.error(sdkUtils.getErrorFromResponse(err)));
  };
}

AttributionLinksEmailModalCtrl.$inject = [
  '$q',
  '$scope',
  '$uibModalInstance',
  'jsSdk.managementUser',
  'alertService',
  'jsSdk.utils',
  'attributionSources',
  'event',
  'jsSdk.event',
  'organizationRelationshipService',
  'organizationMemberService',
  'venueService'
];

export default AttributionLinksEmailModalCtrl;



// WEBPACK FOOTER //
// ./src/modals/attributionLinksEmail/controller.js